'use client';

import { useRef, useState, useEffect } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Stars } from '@react-three/drei';

const AbstractStructure = () => {
    const groupRef = useRef<any>(null);
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const handleResize = () => {
            setScale(window.innerWidth < 1024 ? 0.7 : 1.2);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useFrame((state, delta) => {
        if (groupRef.current) {
            // Complex rotation for "floating" feel
            groupRef.current.rotation.x += delta * 0.1;
            groupRef.current.rotation.y += delta * 0.15;
            groupRef.current.rotation.z += delta * 0.05;
        }
    });

    return (
        <group ref={groupRef} scale={[scale, scale, scale]}>
            {/* The Abstract Shape - TorusKnot for complexity */}
            <mesh>
                <torusKnotGeometry args={[2.5, 0.8, 128, 32]} />
                <meshStandardMaterial
                    color="#6366f1"
                    wireframe
                    transparent
                    opacity={0.15}
                    side={2}
                />
            </mesh>

            {/* Inner Core */}
            <mesh>
                <icosahedronGeometry args={[1.5, 1]} />
                <meshStandardMaterial
                    color="#4f46e5"
                    wireframe
                    transparent
                    opacity={0.3}
                />
            </mesh>

            {/* Floating Particles/Nodes around it */}
            <points>
                <sphereGeometry args={[4, 32, 32]} />
                <pointsMaterial
                    size={0.05}
                    color="#818cf8"
                    transparent
                    opacity={0.4}
                    sizeAttenuation={true}
                />
            </points>
        </group>
    );
};

const ServicesScene = () => {
    return (
        <div className="absolute inset-0 w-full h-full" style={{ zIndex: 0 }}>
            <Canvas
                camera={{ position: [0, 0, 8], fov: 60 }}
                style={{ background: 'transparent' }}
                dpr={[1, 1.5]}
                gl={{ antialias: false, powerPreference: "high-performance" }}
            >
                {/* Lighting */}
                <ambientLight intensity={0.6} />
                <pointLight position={[10, 10, 10]} intensity={1.5} color="#818cf8" />
                <pointLight position={[-10, -10, -10]} intensity={0.8} color="#4f46e5" />

                {/* Starfield for continuity */}
                <Stars
                    radius={50}
                    depth={50}
                    count={1000}
                    factor={4}
                    saturation={0}
                    fade
                    speed={0.5}
                />

                <AbstractStructure />
            </Canvas>
        </div>
    );
};

export default ServicesScene;
